module.exports = __webpack_public_path__ + "img/9791155701157.11876d63.jpg";